<div class="modal-header">
  <h4 class="modal-title me-3">{{ workflow.name }}</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="modalRef.close()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (loading) {
    <div class="d-flex justify-content-center align-content-center pt-2 p-4">
      <mat-spinner class="position-absolute" [diameter]="25"></mat-spinner>
    </div>
  }
  @if (definition !== undefined) {
    <ngx-monaco-editor
      class="full-size"
      #editor
      [options]="editorOptions"
      [(ngModel)]="definition"
    ></ngx-monaco-editor>
  }
  <app-error [error]="error"></app-error>
</div>
<div class="modal-footer">
  <div class="form-check me-auto ms-2">
    <input #lineWrap class="form-check-input" type="checkbox" value="1" />
    <label class="form-check-label">
      {{ 'workflow.line_wrap' | translate }}
    </label>
  </div>
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="modalRef.close()"
  >
    {{ 'close' | translate }}
  </button>
  <button type="button" class="btn btn-secondary" (click)="save()">
    {{ 'save' | translate }}
  </button>
</div>
